export default __webpack_public_path__ + "static/media/not-found.22199ac1.png";